import { render, staticRenderFns } from "./PermissionFolderPersonVisibility.vue?vue&type=template&id=0127972b"
import script from "./PermissionFolderPersonVisibility.vue?vue&type=script&lang=js"
export * from "./PermissionFolderPersonVisibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports